import { ComplexTable } from '@synergy/table';
import { Col, notification, Row, Select } from 'antd';
import clsx from 'clsx';
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import query from '../../../../../server/constants.api';
import useFetch from "../../../../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../../../../styles/global/Pages.styled";
import { booleans, period, periodicity } from '../../../../../utils/config/widgetsConfig';
import Spinner from '../../../Atomics/Spinner';
import { Text } from '../../../Atomics/Text';
import permissionToEdit from '../AccessUtils';
import { buildObj, getCustomizedButtonsForConfiguration } from '../ConfigurationUtils';
import { EditPopupConfigurations } from '../EditPopupConfigurations';

export const SystemLabelConfiguration = ({ ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const allowedToWrite = permissionToEdit(['Configurations', 'AdvancedMetrics', 'SystemLabelConfiguration'])
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedSystemLabel, setSelectedSystemLabel] = useState(null);
    const [isTofecthUnit, setIsToFetchUnit] = useState(false);

    const [idToDelete, setIdToDelete] = useState(null);
    const [isToFetchDelete, setIsToFetchDelete] = useState(false);

    const [isTofecth, setIsToFetch] = useState(false);
    const [bodyToPost, setBodyToPost] = useState(null);
    const [isToEdit, setIsToEdit] = useState(false);

    const {
        data: configs
    } = useFetch("/configurations/system-labels/modal", "configs", null, null, null, query.middlewareURL);

    const {
        data: systemLabels,
        refetch: refetchSystemLabels,
    } = useFetch("/configurations/system-labels", "getSystemLabels", null, null, null, query.middlewareURL);

    let listingData = serealizeData(systemLabels)

    const {
        data: deleted,
    } = useFetch("/configurations/system-labels", "deleteMetricConfig", idToDelete, isToFetchDelete, "DELETE", query.middlewareURL);

    useEffect(() => {
        setIsToFetchDelete(false);
        refetchSystemLabels()
    }, [deleted])

    const {
        data: addOrEditSystemLabels,
        isFetching: addOrEditSystemLabelsIsFetching,
        error: addOrEditSystemLabelsError,
        isSuccess: addOrEditSystemLabelsIsSuccess,
        isError: addOrEditSystemLabelsIsError
    } = useFetch("/configurations/system-labels", "addOrEditSystemLabels", bodyToPost, isTofecth, isToEdit ? 'PUT' : 'POST', query.middlewareURL);

    const {
        data: units,
    } = useFetch("/configurations/unit-code", "getUnitCodes", { label: selectedSystemLabel }, isTofecthUnit, null, query.middlewareURL);

    useEffect(() => { setIsToFetchUnit(false); }, [units])

    useEffect(() => {
        if (addOrEditSystemLabelsIsError) {
            const errorMessage = addOrEditSystemLabelsError?.response?.data?.detailedMessage || t('An error occurred while saving the metric.');

            // Usar uma notificação para exibir o erro
            notification.error({
                message: t('Error'),
                description: errorMessage,
                duration: 3,  // Define a duração da notificação (3 segundos)
            });
        } else if (addOrEditSystemLabels && !addOrEditSystemLabelsIsFetching && addOrEditSystemLabelsIsSuccess) {
            refetchSystemLabels();
            setSelectedRecord(null);
        }
        setIsToFetch(false);
    }, [addOrEditSystemLabelsIsFetching, addOrEditSystemLabelsIsError]);

    const systemLabelConfigurations = [
        {
            title: t('Entity'),
            dataIndex: 'entity',
            fieldTypeId: 3, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/metrics/mapping/entities
            required: true
        },
        {
            title: t('Entity Label'),
            dataIndex: 'entityLabel',
            fieldTypeId: 2,
            required: true
        },
        {
            title: t('Entity Unit'),
            dataIndex: 'entityUnit',
            fieldTypeId: 2,
            required: true
        },
        {
            title: t('System Label'),
            dataIndex: 'systemLabel',
            fieldTypeId: 6, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/metrics/catalog
            required: false,
            customObject: () => {
                return (
                    <Select
                        listHeight={200}
                        size={'large'}
                        bordered={false}
                        placeholder={<span style={{ color: "lightgrey" }}>{t("Select Value")}</span>}
                        options={returnOptions('systemLabel', configs)}
                        onChange={(e, record) => { setSelectedSystemLabel(e); setIsToFetchUnit(true); }}
                        // value={selectedSystemLabel}
                        // defaultValue={selectedSystemLabel}
                        className={clsx('select-atomic', props?.className, 'full-width')} />
                )
            }
        },
        {
            title: t('System Unit'),
            dataIndex: 'systemUnit',
            fieldTypeId: 6, // https://u1g9qpyluh.execute-api.eu-west-1.amazonaws.com/v3_0_01/metrics/catalog?Label=<XXX​>
            required: true,
            customObject: (field) => {
                return (
                    <Select
                        listHeight={200}
                        size={'large'}
                        bordered={false}
                        placeholder={<span style={{ color: "lightgrey" }}>{t("Select Value")}</span>}
                        disabled={units ? false : true}
                        options={returnOptions('systemUnits', units)}
                        className={clsx('select-atomic', props?.className, 'full-width')} />
                )
            }
        },
    ]

    function handleOkModal(selectedRecord, data) {
        const copyData = {
            "Old Entity": selectedRecord?.oldEntity ?? null,
            "Old SortKey": selectedRecord?.oldSortKey ?? null,
            Entity: data?.entity ?? null,
            "Entity Label": data?.entityLabel ?? null,
            "Entity Unit": data?.entityUnit ?? null,
            "System Label": selectedSystemLabel ?? null,
            "System Unit": data?.systemUnit ?? null,
        };
        setBodyToPost(copyData);
        setIsToFetch(true);
        setIsModalOpen(false);
        setSelectedRecord(null);
        refetchSystemLabels();
    }

    useEffect(() => {
        listingData = serealizeData(systemLabels);
    }, [systemLabels])

    function handleEdit(listingData, record) {
        setIsToEdit(true);
        var entity = listingData.find(e => e.entity == record.entity && e.entityLabel == record.entityLabel && e.entityUnit == record.entityUnit);
        setSelectedSystemLabel(entity.systemLabel)
        setSelectedRecord(entity);  // Atualiza o estado com o registro selecionado
        setIsModalOpen(true); // Abre a modal
    }

    function handleCloseModal() {
        setIsModalOpen(false);  // Fecha a modal
        setSelectedRecord(null); // Limpa o registro selecionado
    }

    return (
        <PageContent className={clsx('building_room_details', props?.className)}>
            <PageSection>
                {/* System Labels */}
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <PageTitle>
                                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{t('System Label Mapping List')}</Text>
                                </PageTitle>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        {
                            configs && listingData ?
                                <ComplexTable fetchData={listingData} language={i18next.resolvedLanguage}
                                    tableConfiguration={{ collumnsConfiguration: systemLabelConfigurations }}
                                    editButton={allowedToWrite}
                                    deleteButton={allowedToWrite}
                                    fixedActions={true}
                                    handleDelete={(record) => {
                                        setIdToDelete({ "Entity": record.entity, "Entity Label": record.entityLabel, "Entity Unit": record.entityUnit }); setIsToFetchDelete(true);
                                    }}
                                    pagination={{ pageSize: 5 }}
                                    handleEdit={(record) => { handleEdit(listingData, record) }}
                                    customizedButtons={
                                        getCustomizedButtonsForConfiguration(configs && listingData && allowedToWrite,
                                            () => { setSelectedRecord(systemEmptyRecord); setIsModalOpen(true) }, t)
                                    }
                                />
                                :
                                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Spinner stroke="green" />
                                </div>
                        }
                    </Col>
                    <EditPopupConfigurations
                        openModal={isModalOpen}
                        isToEdit={isToEdit}
                        closeModal={handleCloseModal}
                        onOkModal={(data) => handleOkModal(selectedRecord, data)}
                        selectedRecord={selectedRecord ? serealizeRecordForModal(selectedRecord, configs, systemLabelConfigurations) : null}
                        customWidth={800} />
                </Row>
            </PageSection>
        </PageContent>
    )
}

//Serializer para tornar a modal no formato correto para editar um User, como uma configuração para a Modal
const serealizeRecordForModal = (selectedRecord, configValues, tableRes) => {
    const keysToKeep = tableRes.flatMap(x => {
        if (x.subfields) {
            return [...x.subfields.map(y => y.dataIndex), x.dataIndex];
        } else {
            return x.dataIndex
        }
    });
    const result = tableRes.flatMap(x => {
        var obj = Object.entries(selectedRecord);
        if (x.subfields) {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            var parentObj = buildObj(foundObj, x, null, true, returnOptions, configValues);
            return [({
                childs: x.subfields.map(y => {
                    var foundObj = obj.find(z => z[0] === y.dataIndex);
                    return buildObj(foundObj, y, true, parentObj.key, returnOptions, configValues);
                }), parent: parentObj
            })];
        } else {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            return buildObj(foundObj, x, null, null, returnOptions, configValues);
        }
    }).filter(e => e !== undefined)

    var y = result.filter(x => {
        if (x?.parent) {
            for (var i = 0; i < x.childs.length; i++) {
                if (!keysToKeep.includes(x.childs[i].key))
                    delete x.childs[i]
            }
            return keysToKeep.includes(x.parent.key)
        }
        return keysToKeep.includes(x.key)
    });
    return y;
};

const systemEmptyRecord = {
    oldEntity: null,
    oldSortKey: null,
    entity: null,
    entityLabel: null,
    entityUnit: null,
    systemLabel: null,
    systemUnit: null,
}

function returnOptions(key, configValues) {
    switch (key) {
        case 'tenant':
            if (configValues)
                return configValues[key].result.map(x => { return { label: x.tenant, value: x.tenant } });
        case 'periodicity':
            return periodicity.map(x => { return { lable: x, value: x } });
        case 'period':
            return period.map(x => { return { lable: x, value: x } });
        case 'detailSeperation':
        case 'period':
        case 'history':
            return booleans.map(x => { return { label: x, value: x } });
        case 'widgetType':
            return []
        case 'systemUnits':
            if (configValues)
                return configValues.result.map(x => { return { label: x.Unit, value: x.Unit } })
        case 'systemLabel':
            if (configValues && configValues[key])
                return configValues[key].result.map(x => { return { label: x.Label, value: x.Label } })
        default:
            if (configValues && configValues[key]) {
                if (configValues[key].result) {
                    var x = uniqueObjectsByProperty(configValues[key].result.map(x => { return { label: x, value: x } }), key);
                    return x;
                } else if (Array.isArray(configValues[key])) {
                    var x = uniqueObjectsByProperty(configValues[key]);
                    return x;
                }
            }
            else
                return [];
    }
}

function uniqueObjectsByProperty(array, property) {
    if (property)
        return Array.from(new Set(array.map(item => item[property]))).map(value => ({ label: value, value: value }));
    else
        return Array.from(new Set(array)).map(value => ({ label: value, value: value }));
}

const serealizeData = (values) => {
    if (values) {
        return values.result.map((e, index) => {
            return {
                id: index,//TODO JORGE: Trocar para o ID (necessário começar a criar um ID único para cada registro)
                oldEntity: e["Entity"] ?? null,
                oldSortKey: (e["Entity Label"] + "_" + e["Entity Unit"]) ?? null,
                entity: e["Entity"] ?? null,
                entityLabel: e["Entity Label"] ?? null,
                entityUnit: e["Entity Unit"] ?? null,
                systemLabel: e["System Label"] ?? null,
                systemUnit: e["System Unit"] ?? null,
            }
        })
    }
}